// KAN-1342: dev-мок ручек /conversations с данными макета «GL Chat — редизайн» — для сверки
// экранов 1:1 без бэкенда (NEXT_PUBLIC_DEV_AUTH=1). В сборку прода не попадает: грузится только
// из мок-адаптера.

type Json = Record<string, unknown>;

interface MockConv extends Json {
  id: string;
  type: string;
  title: string;
  peerUserId: string | null;
  memberCount: number;
  unreadCount: number;
  isArchived: boolean;
  notificationsMuted: boolean;
  pinnedAtUtc: string | null;
  isOwner: boolean;
  blockedByMe: boolean;
  blockedMe: boolean;
}

const today = (hh: number, mm: number) => {
  const d = new Date();
  d.setHours(hh, mm, 0, 0);
  return d.toISOString();
};
const daysAgo = (n: number, hh = 12) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  d.setHours(hh, 0, 0, 0);
  return d.toISOString();
};

const conv = (id: string, title: string, type: string, preview: string, sentAtUtc: string, over: Partial<MockConv> = {}): MockConv => ({
  id,
  type,
  title,
  avatarUrl: null,
  peerUserId: type === "direct" ? `u-${id}` : null,
  memberCount: type === "direct" ? 2 : 5,
  lastMessage: { id: `last-${id}`, senderId: `u-${id}`, senderDisplayName: title, preview, sentAtUtc, isDeleted: false },
  unreadCount: 0,
  isArchived: false,
  notificationsMuted: false,
  pinnedAtUtc: null,
  chatListId: null,
  isOwner: false,
  blockedByMe: false,
  blockedMe: false,
  membersCanInvite: true,
  mediaAllowed: true,
  slowMode: false,
  expiresAtUtc: null,
  ...over,
});

const conversations: MockConv[] = [
  conv("zerkalo", "Zerkalo", "direct", "пароль gl2026, залетай", today(20, 16), { unreadCount: 2, pinnedAtUtc: today(9, 0) }),
  conv("karambit", "Karambit", "direct", "ок, заявку скинул", today(18, 12)),
  conv("drift", "Dr1ftKing", "direct", "кто в саппорте?", today(17, 55), { unreadCount: 4, notificationsMuted: true }),
  conv("nyx", "nyxvi", "direct", "Голосовое сообщение · 0:14", daysAgo(1)),
  conv("lissa", "Lissa", "direct", "ок, буду к 20:30", daysAgo(20)),
  conv("mid", "MidWolf", "direct", "спс за игру", daysAgo(1), { isArchived: true }),
  conv("org", "Raspiz Org", "direct", "Приглашение в организацию", daysAgo(23), { unreadCount: 1, blockedMe: true }),
  conv("vexa", "Vexa", "direct", "скинь вод последнего скрима", daysAgo(1)),
  conv("tilted", "TiltedOne", "direct", "я на джангле сегодня", daysAgo(1), { unreadCount: 2 }),
  conv("kiro", "Kiro", "direct", "давай кастомку", daysAgo(21), { unreadCount: 1 }),
  conv("gl-cup", "GL Cup · орги", "organization", "Артём: сетку опубликовал", today(19, 40), { memberCount: 6, pinnedAtUtc: today(8, 0) }),
  conv("team-raspiz", "Raspiz · основа", "team", "Nyx: скрим в 21:00", today(18, 30), { unreadCount: 3, isOwner: true }),
  conv("scrim-tmp", "Скрим 09.09 · временный", "temporary", "Система: чат закроется через 24 ч", today(17, 5), { memberCount: 10 }),
];

let seq = 0;
const mockLists: { id: string; kind: string; title: string }[] = [];
const msg = (id: string, own: boolean, sentAtUtc: string, over: Json = {}): Json => ({
  id,
  conversationId: "zerkalo",
  senderId: own ? "__me__" : "u-zerkalo",
  senderDisplayName: own ? "Вы" : "Zerkalo",
  senderAvatarUrl: null,
  kind: "text",
  body: "",
  payloadJson: null,
  attachments: [],
  sentAtUtc,
  editedAtUtc: null,
  replyTo: null,
  forwardedFromName: null,
  isDeleted: false,
  isDelivered: own,
  isRead: own,
  reactions: [],
  ...over,
});

const PHOTO = "/banners/result-fon.jpg";
const zerkalo: Json[] = [
  msg("m1", false, today(20, 14), {
    body: "го скрим в 21:00, я на мид",
    reactions: [
      { emoji: "🔥", count: 2, userIds: ["u-zerkalo", "__me__"], names: ["Zerkalo", "Вы"], avatars: [null, null] },
      { emoji: "👍", count: 1, userIds: ["u-zerkalo"], names: ["Zerkalo"], avatars: [null] },
    ],
  }),
  msg("m2", false, today(20, 14), { body: "соберём пятёрку из друзей, врагов найдём" }),
  msg("m3", true, today(20, 15), { body: "я за, скинь лобби" }),
  msg("m4", false, today(20, 16), { body: "пароль gl2026, залетай", replyTo: { id: "m3", senderDisplayName: "Вы", preview: "я за, скинь лобби", isDeleted: false } }),
  msg("m5", true, today(20, 18), { body: "лобби собрано", attachments: [{ id: "a5", type: "image", url: PHOTO, thumbnailUrl: null, fileName: "lobby.png", sizeBytes: 820000, width: 1600, height: 900, durationSec: null }] }),
  msg("m6", true, today(20, 18), { body: "ждём ещё двоих" }),
  msg("m9", false, today(20, 20), { body: "по составу: я на джангле, Karambit топ, Nyx мид. нужны адк и саппорт, желательно с голосом — на прошлом скриме половину дрейков отдали из-за того, что никто не пинговал таймеры" }),
  msg("m7", false, today(20, 20), { isDeleted: true }),
  msg("m10", false, today(20, 21), { attachments: [{ id: "a10", type: "voice", url: "about:blank", thumbnailUrl: null, fileName: null, sizeBytes: 514253, width: null, height: null, durationSec: 24 }] }),
  msg("m11", true, today(20, 22), { attachments: [{ id: "a11", type: "voice", url: "about:blank", thumbnailUrl: null, fileName: null, sizeBytes: 222925, width: null, height: null, durationSec: 10 }] }),
  msg("m13", false, today(20, 24), { body: "заявку приняли, группа B, старт в 21:30 по МСК", forwardedFromName: "Karambit" }),
  msg("m15", false, today(20, 26), { body: "итого: **жирный**, _курсив_, __подчёркнутый__, ~~зачёркнутый~~" }),
  msg("m16", false, today(20, 26), { body: "> цитата: старт в 21:30 по МСК" }),
  msg("m17", true, today(20, 27), { body: "лобби `gl2026-final`, пароль ||под спойлером||, сетка [на сайте](https://gltournament.ru)" }),
  msg("m20", true, today(20, 30), {
    body: "скинул материалы по сетке",
    attachments: [
      { id: "f1", type: "file", url: "about:blank", thumbnailUrl: null, fileName: "bracket-final.pdf", sizeBytes: 2202010, width: null, height: null, durationSec: null },
      { id: "f2", type: "file", url: "about:blank", thumbnailUrl: null, fileName: "roster-raspiz.xlsx", sizeBytes: 184320, width: null, height: null, durationSec: null },
    ],
  }),
  msg("m8", true, today(20, 31), { isDeleted: true }),
];

const messagesByConv: Record<string, Json[]> = { zerkalo };
// KAN-1330: закрепы по беседам — id сообщений в порядке закрепления.
const pinsByConv: Record<string, string[]> = { zerkalo: ["m4", "m13"] };

export interface MockChatResult {
  status: number;
  data: unknown;
}

export function handleMockChat(method: string, path: string, params: Json | undefined, body: Json, meId: string): MockChatResult | null {
  if (!path.startsWith("/conversations")) return null;
  const swapMe = (id: unknown) => (id === "__me__" ? meId : id);
  const withMe = (m: Json) => ({
    ...m,
    senderId: swapMe(m["senderId"]),
    reactions: ((m["reactions"] as Json[] | undefined) ?? []).map((r) => ({ ...r, userIds: (r["userIds"] as unknown[]).map(swapMe) })),
  });

  // KAN-1337: приглашение на скрим.
  const mockTeams = { my: { id: "t-my", name: "Мы", tag: "MY", logoUrl: null }, peer: { id: "t-peer", name: "Они", tag: "TH", logoUrl: null } };
  const scrimOpts = path.match(/^\/conversations\/([^/]+)\/cards\/scrim\/options$/);
  if (scrimOpts && method === "get") return { status: 200, data: { myTeams: [mockTeams.my], peerTeams: [mockTeams.peer] } };
  const scrimSend = path.match(/^\/conversations\/([^/]+)\/cards\/scrim$/);
  if (scrimSend && method === "post") {
    const m = { id: `m-${++seq}`, conversationId: scrimSend[1], senderId: "__me__", senderDisplayName: "Shpinat", senderAvatarUrl: null, kind: "scrimInvite", body: "", payloadJson: JSON.stringify({ scrimId: "scrim-1", from: mockTeams.my, to: mockTeams.peer }), attachments: [], sentAtUtc: new Date().toISOString(), editedAtUtc: null, replyTo: null, forwardedFromName: null, isDeleted: false, isDelivered: true, isRead: false, reactions: [] };
    (messagesByConv[String(scrimSend[1])] ??= []).push(m);
    return { status: 200, data: withMe(m) };
  }

  // KAN-1336: карточки LFG/LFT.
  const mockCard = { postId: "post-1", type: "lfg", authorId: "__me__", authorName: "Shpinat", authorAvatarUrl: null, teamName: null, role: "Mid", roles: ["Mid", "Top"], formats: ["Flex"], minRank: "Gold", maxRank: "Platinum", description: "Ищу дуо на флекс по вечерам" };
  if (path === "/conversations/cards/lfg/mine" && method === "get") return { status: 200, data: [mockCard] };
  const lfgSend = path.match(/^\/conversations\/([^/]+)\/cards\/lfg$/);
  if (lfgSend && method === "post") {
    const m = { id: `m-${++seq}`, conversationId: lfgSend[1], senderId: "__me__", senderDisplayName: "Shpinat", senderAvatarUrl: null, kind: "lfg", body: "", payloadJson: JSON.stringify(mockCard), attachments: [], sentAtUtc: new Date().toISOString(), editedAtUtc: null, replyTo: null, forwardedFromName: null, isDeleted: false, isDelivered: true, isRead: false, reactions: [] };
    (messagesByConv[String(lfgSend[1])] ??= []).push(m);
    return { status: 200, data: withMe(m) };
  }

  // KAN-1335: управление группой.
  const groupOne = path.match(/^\/conversations\/([^/]+)$/);
  if (groupOne && method === "patch") {
    const c = conversations.find((x) => x.id === groupOne[1]);
    if (!c) return { status: 404, data: { message: "Not found" } };
    if (typeof body["title"] === "string" && body["title"].trim()) c["title"] = body["title"].trim();
    if (typeof body["avatarUrl"] === "string") c["avatarUrl"] = body["avatarUrl"] || null;
    for (const k of ["membersCanInvite", "mediaAllowed", "slowMode"]) if (typeof body[k] === "boolean") c[k] = body[k];
    return { status: 200, data: c };
  }
  if (groupOne && method === "delete") {
    const i = conversations.findIndex((x) => x.id === groupOne[1]);
    if (i >= 0) conversations.splice(i, 1);
    return { status: 204, data: null };
  }
  if (/^\/conversations\/[^/]+\/invites$/.test(path) && method === "post") {
    return { status: 200, data: { code: "GL-8F2KQ7XM", expiresAtUtc: new Date(Date.now() + 7 * 864e5).toISOString() } };
  }
  if (/^\/conversations\/[^/]+\/owner$/.test(path) && method === "post") return { status: 204, data: null };
  if (/^\/conversations\/[^/]+\/members\/[^/]+$/.test(path) && method === "delete") return { status: 204, data: null };
  if (/^\/conversations\/invites\/[^/]+\/join$/.test(path) && method === "post") return { status: 200, data: conversations[0] };

  // KAN-1334: новая группа.
  if (path === "/conversations/groups" && method === "post") {
    const title = String(body["title"] ?? "").trim();
    const ids = (body["memberIds"] as string[] | undefined) ?? [];
    if (!title || ids.length === 0) return { status: 400, data: { message: "Group title and members are required" } };
    const group = { ...conversations[0]!, id: `group-${++seq}`, type: "custom", title, avatarUrl: null, peerUserId: null, memberCount: ids.length + 1, lastMessage: null, unreadCount: 0, isOwner: true, chatListId: null, pinnedAtUtc: null, isArchived: false };
    conversations.unshift(group);
    return { status: 200, data: group };
  }

  // KAN-1333: личные списки чатов.
  if (path === "/conversations/lists" && method === "get") return { status: 200, data: mockLists };
  if (path === "/conversations/lists" && method === "post") {
    const list = { id: `list-${++seq}`, kind: String(body["kind"]), title: String(body["title"] ?? "").trim().slice(0, 40) };
    if (!list.title) return { status: 400, data: { message: "List title is required" } };
    mockLists.unshift(list);
    return { status: 200, data: list };
  }
  const listOne = path.match(/^\/conversations\/lists\/([^/]+)$/);
  if (listOne && method === "patch") {
    const list = mockLists.find((l) => l.id === listOne[1]);
    if (!list) return { status: 404, data: { message: "List not found" } };
    list.title = String(body["title"] ?? "").trim().slice(0, 40) || list.title;
    return { status: 200, data: list };
  }
  if (listOne && method === "delete") {
    mockLists.splice(0, mockLists.length, ...mockLists.filter((l) => l.id !== listOne[1]));
    conversations.forEach((c) => {
      if (c["chatListId"] === listOne[1]) c["chatListId"] = null;
    });
    return { status: 204, data: null };
  }
  const listMembers = path.match(/^\/conversations\/lists\/([^/]+)\/conversations$/);
  if (listMembers && method === "put") {
    const ids = new Set((body["conversationIds"] as string[] | undefined) ?? []);
    conversations.forEach((c) => {
      if (ids.has(c.id)) c["chatListId"] = listMembers[1]!;
      else if (c["chatListId"] === listMembers[1]) c["chatListId"] = null;
    });
    return { status: 204, data: null };
  }
  const convList = path.match(/^\/conversations\/([^/]+)\/list$/);
  if (convList && method === "put") {
    const c = conversations.find((x) => x.id === convList[1]);
    if (c) c["chatListId"] = (body["listId"] as string | null) ?? null;
    return { status: 204, data: null };
  }

  if (method === "get" && path === "/conversations") {
    const archived = String(params?.["archived"]) === "true";
    return { status: 200, data: conversations.filter((c) => c.isArchived === archived) };
  }
  const direct = path.match(/^\/conversations\/direct\/([^/]+)$/);
  if (method === "post" && direct) {
    let c = conversations.find((x) => x.peerUserId === direct[1]);
    if (!c) {
      c = conv(direct[1]!, direct[1]!, "direct", "", new Date().toISOString(), { lastMessage: null, peerUserId: direct[1]! });
      conversations.push(c);
    }
    return { status: 200, data: c };
  }
  const detail = path.match(/^\/conversations\/([^/]+)$/);
  if (method === "get" && detail) {
    const c = conversations.find((x) => x.id === detail[1]);
    return c ? { status: 200, data: c } : { status: 403, data: { message: "Forbidden" } };
  }
  const list = path.match(/^\/conversations\/([^/]+)\/messages$/);
  if (list && method === "get") {
    return { status: 200, data: { messages: (messagesByConv[list[1]!] ?? []).map(withMe), hasMore: false } };
  }
  if (list && method === "post") {
    const id = `mock-${++seq}`;
    const created = msg(id, true, new Date().toISOString(), {
      conversationId: list[1],
      body: String(body["body"] ?? ""),
      attachments: ((body["attachments"] as Json[] | undefined) ?? []).map((a, i) => ({ id: `${id}-${i}`, fileName: null, thumbnailUrl: null, sizeBytes: null, width: null, height: null, durationSec: null, ...a })),
      isDelivered: false,
      isRead: false,
    });
    (messagesByConv[list[1]!] ??= []).push(created);
    return { status: 200, data: withMe(created) };
  }
  if (path === "/conversations/forward" && method === "post") {
    const ids = (body["messageIds"] as string[] | undefined) ?? [];
    const targets = ((body["conversationIds"] as string[] | undefined) ?? []).map((conversationId) => ({ conversationId, delivered: ids.length, error: null }));
    return { status: 200, data: { targets } };
  }
  const searchM = path.match(/^\/conversations\/([^/]+)\/search$/);
  if (searchM && method === "get") {
    const q = String(params?.["q"] ?? "").toLowerCase();
    const from = params?.["from"] ? Date.parse(String(params["from"])) : null;
    const to = params?.["to"] ? Date.parse(String(params["to"])) : null;
    const found = (messagesByConv[searchM[1]!] ?? [])
      .filter((m) => !m["isDeleted"] && String(m["body"] ?? "").toLowerCase().includes(q))
      .filter((m) => (from === null || Date.parse(String(m["sentAtUtc"])) >= from) && (to === null || Date.parse(String(m["sentAtUtc"])) < to))
      .reverse();
    return { status: 200, data: found.map(withMe) };
  }
  const mediaCounts = path.match(/^\/conversations\/([^/]+)\/media-counts$/);
  const mediaList = path.match(/^\/conversations\/([^/]+)\/media$/);
  const attachmentsOf = (convId: string, type: string) =>
    (messagesByConv[convId] ?? []).flatMap((m) =>
      ((m["attachments"] as Json[] | undefined) ?? []).filter((x) => x["type"] === type).map((x) => ({ m, x })),
    );
  if (mediaCounts && method === "get") {
    const id = mediaCounts[1]!;
    const links = (messagesByConv[id] ?? []).reduce((n, m) => n + (String(m["body"] ?? "").match(/https?:\/\/[^\s]+/g)?.length ?? 0), 0);
    return {
      status: 200,
      data: { photos: attachmentsOf(id, "image").length, videos: attachmentsOf(id, "video").length, files: attachmentsOf(id, "file").length, voices: attachmentsOf(id, "voice").length, links },
    };
  }
  if (mediaList && method === "get") {
    const id = mediaList[1]!;
    const kind = String(params?.["kind"] ?? "photo");
    if (kind === "link") {
      const items = (messagesByConv[id] ?? []).flatMap((m) =>
        (String(m["body"] ?? "").match(/https?:\/\/[^\s]+/g) ?? []).map((url) => ({
          messageId: m["id"], attachmentId: null, kind: "link", url, thumbnailUrl: null, fileName: null, sizeBytes: null, width: null, height: null, durationSec: null,
          title: url.replace(/^https?:\/\//, "").split("/")[0], senderDisplayName: m["senderDisplayName"], sentAtUtc: m["sentAtUtc"],
        })),
      );
      return { status: 200, data: items.reverse() };
    }
    const type = ({ photo: "image", video: "video", file: "file", voice: "voice" } as Record<string, string>)[kind] ?? "image";
    const items = attachmentsOf(id, type).map(({ m, x }) => ({
      messageId: m["id"], attachmentId: x["id"], kind, url: x["url"], thumbnailUrl: x["thumbnailUrl"] ?? null, fileName: x["fileName"] ?? null,
      sizeBytes: x["sizeBytes"] ?? null, width: x["width"] ?? null, height: x["height"] ?? null, durationSec: x["durationSec"] ?? null,
      title: null, senderDisplayName: m["senderDisplayName"], sentAtUtc: m["sentAtUtc"],
    }));
    return { status: 200, data: items.reverse() };
  }
  const pinsList = path.match(/^\/conversations\/([^/]+)\/pins$/);
  const pinOne = path.match(/^\/conversations\/messages\/([^/]+)\/pin$/);
  const pinsOf = (convId: string) =>
    (pinsByConv[convId] ?? []).flatMap((id) => {
      const m = (messagesByConv[convId] ?? []).find((x) => x["id"] === id);
      if (!m || m["isDeleted"]) return [];
      const body = String(m["body"] ?? "");
      return [{ messageId: id, senderDisplayName: m["senderDisplayName"], preview: body || "Сообщение", pinnedAtUtc: m["sentAtUtc"] }];
    });
  if (pinsList && method === "get") return { status: 200, data: pinsOf(pinsList[1]!) };
  if (pinOne && (method === "post" || method === "delete")) {
    for (const [convId, arr] of Object.entries(messagesByConv)) {
      if (!arr.some((x) => x["id"] === pinOne[1])) continue;
      const cur = (pinsByConv[convId] ??= []).filter((id) => id !== pinOne[1]);
      pinsByConv[convId] = method === "post" ? [...cur, pinOne[1]!] : cur;
      return { status: 200, data: pinsOf(convId) };
    }
    return { status: 404, data: null };
  }
  const react = path.match(/^\/conversations\/messages\/([^/]+)\/reactions$/);
  if (react && method === "post") {
    for (const arr of Object.values(messagesByConv)) {
      const m = arr.find((x) => x["id"] === react[1]);
      if (!m) continue;
      const emoji = String(body["emoji"]);
      const groups = [...((m["reactions"] as Json[] | undefined) ?? [])];
      const i = groups.findIndex((g) => g["emoji"] === emoji);
      const g = i < 0 ? null : groups[i]!;
      const ids = ((g?.["userIds"] as string[] | undefined) ?? []).slice();
      const at = ids.indexOf("__me__");
      if (at >= 0) ids.splice(at, 1);
      else ids.push("__me__");
      if (ids.length === 0) groups.splice(i, 1);
      else if (i < 0) groups.push({ emoji, count: 1, userIds: ids, names: ["Вы"], avatars: [null] });
      else groups[i] = { emoji, count: ids.length, userIds: ids, names: ids.map((id) => (id === "__me__" ? "Вы" : "Zerkalo")).slice(0, 3) };
      m["reactions"] = groups;
      return { status: 200, data: { conversationId: m["conversationId"], messageId: m["id"], reactions: withMe(m)["reactions"] } };
    }
    return { status: 404, data: null };
  }
  const del = path.match(/^\/conversations\/messages\/([^/]+)$/);
  if (del && method === "patch") {
    for (const arr of Object.values(messagesByConv)) {
      const i = arr.findIndex((m) => m["id"] === del[1]);
      if (i < 0) continue;
      arr[i] = { ...arr[i], body: String(body["body"] ?? ""), editedAtUtc: new Date().toISOString() };
      return { status: 200, data: withMe(arr[i]!) };
    }
    return { status: 404, data: null };
  }
  if (del && method === "delete") {
    for (const arr of Object.values(messagesByConv)) {
      const i = arr.findIndex((m) => m["id"] === del[1]);
      if (i < 0) continue;
      if (String(params?.["forAll"]) === "true") arr[i] = { ...arr[i], isDeleted: true, body: "", attachments: [] };
      else arr.splice(i, 1);
    }
    return { status: 204, data: null };
  }
  const settings = path.match(/^\/conversations\/([^/]+)\/settings$/);
  if (settings && method === "patch") {
    const c = conversations.find((x) => x.id === settings[1]);
    if (c) {
      if (typeof body["archived"] === "boolean") c.isArchived = body["archived"];
      if (typeof body["notificationsMuted"] === "boolean") c.notificationsMuted = body["notificationsMuted"];
      if (typeof body["pinned"] === "boolean") c.pinnedAtUtc = body["pinned"] ? new Date().toISOString() : null;
    }
    return { status: 204, data: null };
  }
  const read = path.match(/^\/conversations\/([^/]+)\/(read|delivered)$/);
  if (read) {
    const c = conversations.find((x) => x.id === read[1]);
    if (c && read[2] === "read") c.unreadCount = 0;
    return { status: 204, data: null };
  }
  return { status: 404, data: { message: "Not Found" } };
}
